import { render, staticRenderFns } from "./GenerateWidget.vue?vue&type=template&id=72f6ee82&"
import script from "./GenerateWidget.vue?vue&type=script&lang=js&"
export * from "./GenerateWidget.vue?vue&type=script&lang=js&"
import style0 from "./GenerateWidget.vue?vue&type=style&index=0&id=72f6ee82&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDialog,QCard,QForm,QCardSection,QSpace,QInnerLoading,QSpinnerTail,QInput,QTabs,QTab,QTabPanels,QTabPanel,QBtnToggle,QToggle,QTooltip,QBtn,QField} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QForm,QCardSection,QSpace,QInnerLoading,QSpinnerTail,QInput,QTabs,QTab,QTabPanels,QTabPanel,QBtnToggle,QToggle,QTooltip,QBtn,QField})
